import { RelatedIncidentsList } from "./RelatedIncidentsList";

export * from "./RelatedIncidentsList";
export default RelatedIncidentsList;
